import { useState } from 'preact/hooks';

interface ChatBubbleProps {
  isOpen: boolean;
  onClick: () => void;
}

const bubbleStyle: Record<string, string | number> = {
  width: '60px',
  height: '60px',
  borderRadius: '9999px',
  background: 'var(--bb-primary, #4D5D32)',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 4px 12px rgba(0,0,0,0.25), 0 0 0 3px rgba(255,255,255,0.9)',
  cursor: 'pointer',
  border: 'none',
  transition: 'transform 150ms ease, background 150ms ease, box-shadow 150ms ease',
};

const bubbleHoverStyle: Record<string, string | number> = {
  ...bubbleStyle,
  transform: 'scale(1.05)',
  background: '#3d4a27',
  boxShadow: '0 6px 16px rgba(0,0,0,0.3), 0 0 0 3px rgba(255,255,255,1)',
};

const iconStyle: Record<string, string | number> = {
  width: '28px',
  height: '28px',
  transition: 'transform 250ms ease',
};

const iconOpenStyle: Record<string, string | number> = {
  ...iconStyle,
  transform: 'rotate(45deg)',
};

// Chat icon SVG
const ChatIcon = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

// Close icon SVG
const CloseIcon = () => (
  <svg style={iconOpenStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export function ChatBubble({ isOpen, onClick }: ChatBubbleProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      style={isHovered ? bubbleHoverStyle : bubbleStyle}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label={isOpen ? 'Stäng chatt' : 'Öppna chatt'}
    >
      {isOpen ? <CloseIcon /> : <ChatIcon />}
    </button>
  );
}
